import { Suspense, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { onDesktopDeepLink } from './utils/desktopNotify';
import Home from './Components/Pages/Home';
import Header from './Components/Header';
import AuthRouters from './modules/auth/authRouters';
import AdminRouters from './modules/admin/adminRouters';
import WarehouseRouters from './modules/warehouse/warehouseRouters';
import ShipmentsRouters from './modules/shipments/shipmentsRouters';
import PhoneExpensesRouters from './modules/phoneExpenses/phoneExpensesRouters';
import PaymentsRouters from './modules/payments/paymentsRouters';
import TelephonyRouters from './modules/telephony/telephonyRouters';
import { AuthProvider } from './modules/auth/context/AuthContext';
import IncomingCallProvider from './Components/Telephony/IncomingCallProvider';
import { ThemeProvider } from './theme/ThemeContext';
import pkg from '../package.json';
import AppUpdateWatcher from './Components/AppUpdateWatcher';
import BackendUnavailableScreen from './Components/BackendUnavailableScreen';

// Fallback при ленивой подгрузке страниц модулей (warehouse/shipments/admin).
export function RouteFallback() {
  return (
    <div style={{ padding: '48px 0', textAlign: 'center', color: 'var(--spark-color-text-muted)' }}>
      Завантаження…
    </div>
  );
}

// Desktop (Tauri): перехід на сторінку з посилання spark://open?to=... (листи).
function DesktopDeepLink() {
  const navigate = useNavigate();
  useEffect(() => onDesktopDeepLink((target) => navigate(target)), [navigate]);
  return null;
}

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'demo') {
      document.title = 'Zeus SPARK · DEMO';
    }
  }, []);

  // Desktop-обёртка (Tauri) сама не знает версию сайта — передаём её,
  // чтобы она попала в заголовок окна (см. desktop/src-tauri/src/lib.rs).
  useEffect(() => {
    if (window.__TAURI__) {
      window.__TAURI__.core.invoke('set_site_version', { version: pkg.version }).catch(() => {});
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <IncomingCallProvider>
          <div className="App">
            <Header />
            <AppUpdateWatcher />
            <DesktopDeepLink />
            <BackendUnavailableScreen />
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/auth">
                  {AuthRouters}
                </Route>
                <Route path="/warehouse">
                  {WarehouseRouters}
                </Route>
                <Route path="/shipments">
                  {ShipmentsRouters}
                </Route>
                <Route path="/phone-expenses">
                  {PhoneExpensesRouters}
                </Route>
                <Route path="/payments">
                  {PaymentsRouters}
                </Route>
                <Route path="/telephony">
                  {TelephonyRouters}
                </Route>
                <Route path="/admin">
                  {AdminRouters}
                </Route>
              </Routes>
            </Suspense>
          </div>
        </IncomingCallProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
